import { ComponentProps } from 'react'

import styled from 'styled-components'
import { overflow, OverflowProps, zIndex, ZIndexProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import Adapter from './Adapter'

export const Header = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  z-index: 3;
  padding: ${themeGet('space.4')}px;
  color: ${themeGet('colors.primary.main')};
`

export type StyledModalProps = ComponentProps<typeof Adapter> &
  OverflowProps &
  ZIndexProps

export const StyledModal = styled(Adapter).attrs<StyledModalProps>({
  modalClassName: {
    base: 'Modal',
    afterOpen: 'Modal--after-open',
    beforeClose: 'Modal--before-close',
  },
  overlayClassName: {
    base: 'Overlay',
    afterOpen: 'Overlay--after-open',
    beforeClose: 'Overlay--before-close',
  },
})`
  .Overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${themeGet('colors.overlay.deep')};
    transition: all 100ms;
    z-index: 2000;
    outline: none;
    opacity: 0;

    &--after-open {
      opacity: 1;
    }

    &--before-close {
      opacity: 0;
    }

    ${zIndex}
  }

  .Modal {
    position: relative;
    display: flex;
    flex-direction: column;
    max-height: 98vh;
    min-width: 350px;
    width: min-content;
    background: ${themeGet('colors.background.screen')};
    box-shadow: 0 1px 64px -2px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    color: ${themeGet('colors.text.body')};
    overflow-y: auto;
    overflow-x: hidden;
    transition: all 100ms;
    outline: none;
    opacity: 0;

    &--after-open {
      opacity: 1;
    }

    &--before-close {
      opacity: 0;
    }

    ${overflow}
  }
`

export const XButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;

  > svg {
    width: 16px;
    height: 16px;
  }
`
